var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lab-task',[_c('lab-solubility-iodate',{attrs:{"conc-thiosulfate":_vm.concThiosulfate,"ksp":_vm.ksp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }